import React, { useState, useEffect, use } from 'react';
import { Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,Snackbar, Alert, Box, Typography, TextField, MenuItem, Button, CircularProgress, Accordion, AccordionSummary, AccordionDetails, Grid,   IconButton,
  Grid2,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axiosInstance from '../utils/api';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock'; // Import the Lock icon
import { Tooltip } from '@mui/material';


const scores = ['Pass', 'Improvement Required', 'Significant Improvement Required'];


const scoreRank = {
  'Pass': 0,
  'Improvement Required': 1,
  'Significant Improvement Required': 2
};

const getStatusColor = (status) => {
  switch (status) {
    case 'Pass':
      return '#4CAF50'; // Green
   
    case 'Improvement Required':
      return '#FFBF00'; // Dark amber
    case 'Significant Improvement Required':
      return 'red';
    default:
      return 'black';
  }
};

const NewLenderAudit = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentStatus, setCurrentStatus] = useState('Pass');
  const [questionScores, setQuestionScores] = useState({});
  const [jobData, setJobData] = useState({});
  const [auditorComments, setAuditorComments] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' or 'error'
  const [auditData, setAuditData] = useState({});
  const [jobAttachments, setJobAttachments] = useState([]);
  const [jobId, setJobId] = useState(null);
  const [attachmentsDialogOpen, setAttachmentsDialogOpen] = useState(false);
  const [completion, setCompletion] = useState(null);
  const [readOnly, setReadOnly] = useState(false); // State to manage read-only mode
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [completedUser, setCompletedUser] = useState(null); // State to manage completed user
  const [prevAudits, setPrevAudits] = useState([]); // State to manage previous audits
  const [prevAuditsDialogOpen, setPrevAuditsDialogOpen] = useState(false); // State to manage previous audits dialog
  const [prevJobsDialogOpen, setPrevJobsDialogOpen] = useState(false); // State to manage previous jobs dialog
  const [prevJobs, setPrevJobs] = useState([]); // State to manage previous jobs
  const [rightmoveSct, setRightmoveSct] = useState(null); // State to manage Rightmove SCT data
  const [resultDifference,  setResultDifference] = useState(null); // State to manage result differences


  // useEffect to update overall score on result differnce chagne 

  useEffect(() => {
    updateOverallScore();
  }, [resultDifference]);


  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleConfirmSubmit = (event) => {
    handleDialogClose(); // Close the dialog
    completionSubmit(event); // Call the existing completionSubmit function
  };
  const handleOpenAttachmentsDialog = () => {
    setAttachmentsDialogOpen(true);
  };

  const handleOpenPrevAuditsDialog = () => {
    setPrevAuditsDialogOpen(true);
  }
  const handleOpenPrevJobsDialog = () => {
    setPrevJobsDialogOpen(true);
  }
  const handleCloseAttachmentsDialog = () => {
    setAttachmentsDialogOpen(false);
  };
  useEffect(() => {
    axiosInstance('/api/questions/')
      .then((response) => {
        if (!response.status === 200) {
          throw new Error('Network response was not ok');
        }
        return response.data;
      })
      .then((data) => {
        const sortedQuestions = data.sort((a, b) => a.id - b.id);

        setQuestions(sortedQuestions);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
      });
  }, []);

  // load job data from api 
  useEffect(() => {
    var audit_id = window.location.pathname.split('/').pop();
    axiosInstance(`/api/job-data/${audit_id}/`).then((response) => {
      if (!response.status == 200) {
        throw new Error('Network response was not ok');
      }
      return response.data;
    }
    ).then((data) => {
      setJobData(data.job_data);
      setJobId(data.job_data.JobId);
    })
  },[])

  useEffect(() => {
    if (jobId){
      axiosInstance(`/api/prev-audits/${jobId}/`)
        .then((response) => {
          if (!response.status === 200) {
            throw new Error('Network response was not ok');
          }
          return response.data;
        })
        .then((data) => {
          // remove the current audit from the list of previous audits
          if (data && data.audits) {
            const filteredAudits = data.audits.filter(audit => audit.audit_id !== window.location.pathname.split('/').pop());
            setPrevAudits(filteredAudits);
          }
          else {
            setPrevAudits([]);
          }
        })
        .catch((error) => {
          setError(error);
        })
        ;
      axiosInstance(`/api/prev-jobs/${jobId}`)
        .then((response) => {
          if (!response.status === 200) {
            throw new Error('Network response was not ok');
          }
          return response.data;
        })
        .then((data) => {
          setPrevJobs(data.previous_jobs);
        })
        axiosInstance(`/api/retrieve-rightmove-sct/${jobData.JobRef}`)
        .then((response) => {
          if (!response.status === 200) {
            throw new Error('Network response was not ok');
          }
          return response.data;
        })
        .then((data) => {
          setRightmoveSct(data.sct_data);
        })

    }}, [jobId]);

  useEffect(() => {
    if (jobId) { // Only run if jobId is not null
            axiosInstance(`/api/job-attachments/${jobId}`)
              .then((response) => {
                if (response.status !== 200 && response.status !== 204) {
                  throw new Error('Network response was not ok');
                }
                return response.data;
              })
              .then((data) => {
                var attachments = [];
                if (!data.attachments) {
                  setJobAttachments([]);
                  return;
                }
                for (let attachment of data.attachments) {
                  if (attachment.FileExtension.toLowerCase() === '.pdf') {
                    attachments.push(attachment);
                  }
                }
                setJobAttachments(attachments);
              })
              .catch((error) => {
                setError(error);
              });
        }
    }, [jobId]);

  useEffect(() => {
    axiosInstance(`/api/audit/${window.location.pathname.split('/').pop()}/`)
      .then((response) => {
        if (!response.status === 200) {
          throw new Error('Network response was not ok');
        }
        setAuditData(response.data.audits);

        setResultDifference(response.data.audits.result_difference);
        setReadOnly(response.data.audits.completed_by); // Set read-only mode based on audit data
        setAuditorComments(response.data.audits.auditor_comments); // Populate auditor comments
        setQuestionScores(response.data.audits.results); 
        setCurrentStatus(response.data.audits.overall_score || 'Pass'); // Populate current status
      })}, [])

  useEffect(() => {
    if (readOnly && auditData.completed_by) {
      axiosInstance(`/api/user/${auditData.completed_by}/`)
        .then((response) => {
          if (!response.status === 200) {
            throw new Error('Network response was not ok');
          }
          setCompletedUser(response.data);
        })
        .catch((error) => {
          setError(error);
        });
    }
  
  }, [readOnly, auditData.completed_by]);
  useEffect(() => {
    if (questions.length > 0) {
      const initialScores = questions.reduce((acc, question) => {
        acc[question.id] = question.score || 'Pass';
        return acc;
      }, {});
      setQuestionScores(initialScores);
    }
  }, [questions]);

  useEffect(() => {
    if (Object.keys(questionScores).length > 0) {
      const worstScore = Object.values(questionScores).reduce((worst, score) => {
        return scoreRank[score] > scoreRank[worst] ? score : worst;
      }, currentStatus);
      setCurrentStatus(worstScore);

    }
  }, [questionScores]);
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleScoreChange = (questionId, newScore) => {
    // Update the question scores
    setQuestionScores((prevScores) => {
        const updatedScores = {
            ...prevScores,
            [questionId]: newScore,
        };

        // Dynamically calculate the overall score based on the updated scores
        const scores = Object.values(updatedScores);
        if (scores.length === 0) {
            setCurrentStatus('Pass'); // Default status if no scores are available
        } else {
            const highestRank = Math.max(...scores.map((score) => scoreRank[score]));
            const overallScore = Object.keys(scoreRank).find((key) => scoreRank[key] === highestRank);
            setCurrentStatus(overallScore);
        }

        return updatedScores;
    });
  };

  const updateOverallScore = () => {
    // Calculate the overall score based on the individual question scores
    const scores = Object.values(questionScores);
    // add the result difference to the scores array
    if (resultDifference) {
      scores.push(resultDifference);
    }
    if (scores.length === 0) {
        setCurrentStatus('Pass'); // Default status if no scores are available
        return;
    }

    const highestRank = Math.max(...scores.map((score) => scoreRank[score]));
    const overallScore = Object.keys(scoreRank).find((key) => scoreRank[key] === highestRank);
    setCurrentStatus(overallScore);
  };

  const completionSubmit = (event) => {
    const user = JSON.parse(localStorage.getItem('user'));
    setCompletion(user.user_id);

    setReadOnly(true); // Set read-only mode to true
    handleSubmit(event, user.user_id); // Pass user ID to handleSubmit
  };

  const returnToList = () => {
    window.location.href = '/jobs/all';
  };



  const handleSubmit = (event, completionValue) => {
    event.preventDefault();
    var audit_id = window.location.pathname.split('/').pop();

    // build the data including the questionScores, the currentStatus, and the jobData

      const auditData = {
        jobId: jobData.JobId,
        jobRef: jobData.JobRef,
        address: jobData.Address,
        resourceName: jobData.ResourceName,
        currentStatus: currentStatus,
        questionScores: questionScores,
        auditorComments: auditorComments,
        completedBy:completionValue,
        resultDifferences: resultDifference,

      };
 
    axiosInstance.put(`/api/audit/${audit_id}/`, auditData).then((response) => {
      if (!response.status === 200) {
        setSnackbarMessage(`Error submitting form: ${error.message}`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        throw new Error('Network response was not ok');
      }
      setSnackbarMessage('Form submitted successfully!');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      
    })
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography variant="h6" color="error">
          Error loading questions: {error.message}
        </Typography>
      </Box>
    );
  }

  // Group questions by category
  const groupedQuestions = questions.reduce((acc, question) => {
    const category = question.question_category || 'Uncategorized';
    if (!acc[category]) {
      acc[category] = [];
    }

    acc[category].push(question);
    return acc;
  }, {});


  // Function to handle opening a standalone browser popout window
  const handleInfoClick = (question) => {
    const popoutContent = `
      <html>
        <head>
          <title>Guidance for ${question.text}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            h1 {
              color: #1976d2;
            }
            p {
              font-size: 16px;
              line-height: 1.5;
            }
          </style>
        </head>
        <body>
          <h1>Information about ${question.text}</h1>
          
          ${
            question.question_pass_criteria ? `
            <p><strong>Pass Criteria:</strong> ${question.question_pass_criteria}</p>
            ` : ''
          }
          ${
            question.question_improvement_required_criteria ? `
            <p><strong>Improvement Required Criteria:</strong> ${question.question_improvement_required_criteria}</p>
            ` : ''
          }
         
          ${
            question.question_significant_improvement_required_criteria ? `
            <p><strong>Significant Improvement Required Criteria:</strong> ${question.question_significant_improvement_required_criteria}</p>
            ` : ''
          }
        </body>
      </html>
    `;

    const popoutWindow = window.open('', '_blank', 'width=600,height=400');
    popoutWindow.document.write(popoutContent);
    popoutWindow.document.close();
  };


  const substring_in_array = (a, b) => {
      // Accept either (array, substring) or (substring, array)
      let arr, substr;
      if (Array.isArray(a) && typeof b === 'string') {
        arr = a; substr = b;
      } else if (Array.isArray(b) && typeof a === 'string') {
        arr = b; substr = a;
      } else {
        return false;
      }

      if (!arr || arr.length === 0) return false; // no reasons -> fail

      const needle = substr.toLowerCase().trim();
      // Every audit reason must contain the substring (case-insensitive).
      return arr.every(item =>
        typeof item === 'string' && item.toLowerCase().includes(needle)
      );
    }
  // Function to format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto', p: 3 }}>
      
      <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 3,
            mb: 4,
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#ffffff',
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={5} sx={{ textAlign: 'top', mr: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                Job Reference: <span style={{ color: '#1976d2' }}>{jobData.JobRef}</span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Address: <span style={{ color: '#1976d2' }}>
                  {`${jobData.Address?.HouseNumber ?? ''} ${jobData.Address?.HouseName ?? ''} ${jobData.Address?.Street ?? ''} ${jobData.Address?.Town ?? ''} ${jobData.Address?.Postcode ?? ''}`.trim()}
                </span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Resource Name: <span id={jobData.ResourceId} style={{ color: '#1976d2' }}>{jobData.ResourceName}</span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Lender: <span style={{ color: '#1976d2' }}>{jobData.LenderName}</span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Job Type: <span style={{ color: '#1976d2' }}>{jobData.Product}</span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Audit Type: <span style={{ color: '#1976d2' }}>
                  
                {auditData.reason_names?.join(', ')}

                </span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Audit creation reason: <span style={{ color: '#1976d2' }}>{auditData.creation_comments}</span>
              </Typography>
             
          
              <Button
                variant="contained"
                color="primary"
                href={`https://countrywide.surveyhublive.net/web/Jobs/Job/Details?id=${jobData.JobId}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mt: 2 }}
              >
                View on Survey Hub
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenAttachmentsDialog}
                sx={{ mt: 2, ml: 2 }}
              >
                View Attachments
              </Button> 
              
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenPrevAuditsDialog}
                sx={{ mt: 2, ml: 2 }}
              >
                View Previous Audits ({ prevAudits && prevAudits.length  > 0 ? prevAudits.length : '0' })
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenPrevJobsDialog}
                sx={{ mt: 2, ml:2}}
              >
                View Previous Jobs ({ prevJobs && prevJobs.length  > 0 ? prevJobs.length : '0' })
              </Button>
              {
                rightmoveSct && (
                  <Button
                variant="contained"
                color="primary"
                href={rightmoveSct}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mt: 2, ml:2 }}
              >
                View SCT on Rightmove+
              </Button>
                )
              }
              
            </Grid>
            <Grid item xs={3} >
             
            <Typography variant="h6" sx={{ color: '#555' }}>
                QV Ref: <span style={{ color: '#1976d2' }}>{jobData.QVRef}</span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
              Estimated Value: <span style={{ color: '#1976d2' }}>
                £{jobData.EstimatedValue ? Number(jobData.EstimatedValue).toLocaleString() : ''}
              </span>              
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Advance: <span style={{ color: '#1976d2' }}>
                  £{jobData.Advance ? Number(jobData.Advance).toLocaleString() : ''}
                </span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                Valuation: <span style={{ color: '#1976d2' }}>
                  £{jobData.Valuaton ? Number(jobData.Valuaton).toLocaleString() : ''}
                </span>
              </Typography>
              <Typography variant="h6" sx={{ color: '#555' }}>
                LTV: <span style={{ color: '#1976d2' }}>{jobData.LTV}%</span>
              </Typography>
              {
                prevAudits && prevAudits.length > 0 && (
                <Typography variant="h6" sx={{ color: '#555' }}>
                  Previous Audit Result: <span style={{ color: '#1976d2' }}>{prevAudits[0].overall_score}</span>
                </Typography>
                )

              }
            </Grid>
            <Grid item xs={3} sx={{ textAlign: 'right' }}>
              <Typography
                variant="h6"
                sx={{
                  color: getStatusColor(currentStatus),
                  fontWeight: 'bold',
                }}
              >
                Current Status: {currentStatus}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ textAlign: 'left', mt: 2 }}>
              {readOnly && completedUser &&  (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LockIcon sx={{ color: '#d32f2f', fontSize: 40 }} titleAccess="This case is locked" />
                  <Typography variant="subtitle1" sx={{ color: '#d32f2f', fontStyle: 'italic' }}>
                    This audit is locked and cannot be edited. Completed By: {completedUser.first_name + ' ' + completedUser.last_name}, Completed At: {formatDate(auditData.completed_at)}.
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      {
        Array.isArray(auditData.reason_names) && substring_in_array(auditData.reason_names,'QualityShield') && 

          (
            <>
            <form onSubmit={handleSubmit}>
            {Object.keys(groupedQuestions).map((category) => (

              (category == 'Targeted Audit') && (
                <Accordion key={category} sx={{ mb: 4, opacity: 0.7, color: 'black', backgroundColor: '#f2f2f2f9' }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">{category}</Typography>
                    
                  </AccordionSummary>
                  <AccordionDetails>
                    {groupedQuestions[category].map((question) => (
                      <Box key={question.id} sx={{ mb: 2 }}>
                        <Typography variant="h6" gutterBottom>
                          {question.text}
                          <IconButton onClick={() => handleInfoClick(question)} variant="outlined" sx={{ ml: 2,width : 20, height: 20 }}>
                            <InfoIcon />
                          </IconButton>
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          variant="outlined"
                          label="Score"
                          disabled={readOnly} // Disable if in read-only mode
                          value={questionScores[question.id] || 'Pass'}
                          onChange={(e) => handleScoreChange(question.id, e.target.value)}
                        >
                          {scores.filter(score => {
                            if (score === 'Significant Improvement Required' && !question.question_significant_improvement_required_criteria) {
                              return false;
                            }
                            if (score === 'Improvement Required' && !question.question_improvement_required_criteria) {
                              return false;
                            }
                            if (score === 'Pass' && !question.question_pass_criteria) {
                              return false;
                            }
                            // Add similar checks for other scores if their criteria are null
                            return true;
                          }).map((score) => (
                            <MenuItem key={score} value={score}>
                              {score}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              )
            ))}
            <Typography variant="h6" gutterBottom>
              Auditor Comments
            </Typography>
            <TextField
              disabled={readOnly} // Disable if in read-only mode
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="Auditor Comments"
              value={auditorComments}
              onChange={(e) => setAuditorComments(e.target.value)}
            />
            {
            
              !readOnly ? (
                <>
                  <Button variant="contained" color="primary" sx={{ marginTop: 2, marginRight:1 }} type="submit">
                    Save
                  </Button>
                  <Tooltip title={(auditorComments==='' || auditorComments===null) && currentStatus !== 'Pass' ? "Auditor comments mandatory" : ""}>
                    <span>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ marginTop: 2, marginLeft: 1 }}
                      type="button"
                      onClick={handleDialogOpen} // Open the confirmation dialog
                      disabled={(auditorComments==='' || auditorComments===null) && currentStatus !== 'Pass' }

                    >
                      Submit & Close
                    </Button>
                    </span>
                  </Tooltip>
                </>
              ) : (
                <Button variant="contained" color="primary" sx={{ marginTop: 2, marginRight:1 }} type="button" onClick={returnToList}>
                  Close
                </Button>
              )
            }
            </form>
            </>
          )
        

        || (
          <form onSubmit={handleSubmit}>
            <Typography variant="h6" gutterBottom>
              Was the report compliant with the original suspension reason (see Audit Creation Reason above)?
            </Typography>
            <TextField
              select
              disabled={readOnly} // Disable if in read-only mode
              fullWidth
              variant="outlined"
              label="Yes (Pass) or No (improvement required) or No (significant improvement required)"
              value={resultDifference || ''}
              onChange={(e) => setResultDifference(e.target.value)}
              sx={
                
                {mb: 4}
              }
            >
              <MenuItem key={'Pass'} value={'Pass'}>
                            {'Yes (Pass)'}
              </MenuItem>
              <MenuItem key={'Improvement Required'} value={'Improvement Required'}>
                            {'No (Improvement Required)'}
              </MenuItem>
              <MenuItem key={'Significant Improvement Required'} value={'Significant Improvement Required'}>
                            {'No (Significant Improvement Required)'}
              </MenuItem>
            </TextField>
            {Object.keys(groupedQuestions).map((category) => (
              (category != 'Targeted Audit') && (

              <Accordion key={category} sx={{ mb: 4, opacity: 0.7, color: 'black', backgroundColor: '#f2f2f2f9' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">{category}</Typography>
                  
                </AccordionSummary>
                <AccordionDetails>
                  {groupedQuestions[category].map((question) => (
                    <Box key={question.id} sx={{ mb: 2 }}>
                      <Typography variant="h6" gutterBottom>
                        {question.text}
                        <IconButton onClick={() => handleInfoClick(question)} variant="outlined" sx={{ ml: 2,width : 20, height: 20 }}>
                          <InfoIcon />
                        </IconButton>
                      </Typography>
                      <TextField
                        select
                        fullWidth
                        variant="outlined"
                        label="Score"
                        disabled={readOnly} // Disable if in read-only mode
                        value={questionScores[question.id] || 'Pass'}
                        onChange={(e) => handleScoreChange(question.id, e.target.value)}
                      >
                        {scores.filter(score => {
                          if (score === 'Significant Improvement Required' && !question.question_significant_improvement_required_criteria) {
                            return false;
                          }
                          if (score === 'Improvement Required' && !question.question_improvement_required_criteria) {
                            return false;
                          }
                          if (score === 'Pass' && !question.question_pass_criteria) {
                            return false;
                          }
                          // Add similar checks for other scores if their criteria are null
                          return true;
                        }).map((score) => (
                          <MenuItem key={score} value={score}>
                            {score}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
              )
            ))}
            
            <Typography variant="h6" gutterBottom>
              Auditor Comments
            </Typography>
            <TextField
              disabled={readOnly} // Disable if in read-only mode
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="Auditor Comments"
              value={auditorComments}
              onChange={(e) => setAuditorComments(e.target.value)}
            />
            {
            
              !readOnly ? (
                <>
                  <Button variant="contained" color="primary" sx={{ marginTop: 2, marginRight:1 }} type="submit">
                    Save
                  </Button>
                  <Tooltip title={(auditorComments==='' || auditorComments===null) && currentStatus !== 'Pass' ? "Auditor comments mandatory" : ""}>
                    <span>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ marginTop: 2, marginLeft: 1 }}
                      type="button"
                      onClick={handleDialogOpen} // Open the confirmation dialog
                      disabled={(auditorComments==='' || auditorComments===null) && currentStatus !== 'Pass' }

                    >
                      Submit & Close
                    </Button>
                    </span>
                  </Tooltip>
                </>
              ) : (
                <Button variant="contained" color="primary" sx={{ marginTop: 2, marginRight:1 }} type="button" onClick={returnToList}>
                  Close
                </Button>
              )
            }
          </form>
        )
      }
      
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
      >
        <DialogTitle>Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to submit and close this job? This action will lock the job and make it read-only.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleConfirmSubmit} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    <Dialog open={attachmentsDialogOpen} onClose={handleCloseAttachmentsDialog} fullWidth maxWidth="md">
    <DialogTitle>Job Attachments</DialogTitle>
    <DialogContent>
      { jobAttachments && jobAttachments.length > 0 ? (
        jobAttachments.map((attachment, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="body1">
              <strong>File Name:</strong> {attachment.FileName}
            </Typography>
            <Typography variant="body1">
              <strong>File Extension:</strong> {attachment.FileExtension}
            </Typography>
            <Typography variant="body1">
              <strong>Category:</strong> {attachment.Title}
            </Typography>
            <Typography variant="body1">
            {attachment.FileExtension.toLowerCase() === '.pdf' ? (
              <Button
                href={
                  attachment.AttachmentType === 'JobAttachment'
                    ? `https://countrywide.surveyhublive.net/web/Jobs/JobAttachments/Download/${attachment.Id}`
                    : `https://countrywide.surveyhublive.net/web/Jobs/JobSurveyDetails/Download/${attachment.Id}`

                  }
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                color="primary"
              >
                View PDF
              </Button>
            ) : (
              <Button
                href={
                  attachment.AttachmentType === 'JobAttachment'
                    ? `https://countrywide.surveyhublive.net/web/Jobs/JobAttachments/Download/${attachment.Id}`
                    : `https://countrywide.surveyhublive.net/web/Jobs/JobSurveyDetails/Download/${attachment.Id}`

                  }
                
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                color="primary"
              >
                Download Attachment
              </Button>
            )}
            </Typography>
          </Box>
        ))
      ) : (
        <Typography variant="body1">No attachments available.</Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseAttachmentsDialog} color="primary">
        Close
      </Button>
    </DialogActions>
    </Dialog>
    

    <Dialog open={prevAuditsDialogOpen} onClose={() => setPrevAuditsDialogOpen(false)} fullWidth maxWidth="md">

      <DialogTitle>Previous Audits</DialogTitle>
      { prevAudits && prevAudits.length > 0 ? (
        <DialogContent>
          {prevAudits.map((audit, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography variant="body1">
                <strong>Audit ID:</strong> {audit.audit_id}
              </Typography>
              <Typography variant="body1">
                <strong>Reason(s):</strong> { audit.reason_names ? audit.reason_names.join(', ') : 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Completed By:</strong> {audit.completed_by ? audit.completed_by.first_name + ' ' + audit.completed_by.last_name : 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Completed At:</strong> {formatDate(audit.completed_at)}
              </Typography>
              <Typography variant="body1">
                <strong>Overall Score:</strong> {audit.overall_score}
              </Typography>
              <Typography variant="body1">
                <strong>Auditor Comments:</strong> {audit.auditor_comments || 'No comments provided.'}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                href={`/jobs/audit/${audit.audit_id}`}
                sx={{ mt: 1 }}
                >View Scorecard
              </Button>
            </Box>
          ))}
        </DialogContent>
      ) : (
        <DialogContent>
          <Typography variant="body1">No previous audits available.</Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={() => setPrevAuditsDialogOpen(false)} color="primary">
          Close
        </Button>
      </DialogActions>
      </Dialog>  


      <Dialog open={prevJobsDialogOpen} onClose={() => setPrevJobsDialogOpen(false)} fullWidth maxWidth="md">

        <DialogTitle>Previous Jobs</DialogTitle>
        { prevJobs && prevJobs.length > 0 ? (
          <DialogContent>
            {prevJobs.map((job, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Typography variant="body1">
                  <strong>Job Reference:</strong> {job.CWREF}
                </Typography>
                
                <Typography variant="body1">
                  <strong>Lender:</strong> {job.LenderName}
                </Typography>

                <Typography variant="body1">
                  <strong>Created At:</strong> {formatDate(job.CreatedUtc)}
                </Typography>
                
                <Button
                  variant="contained"
                  color="primary"
                  href={`https://countrywide.surveyhublive.net/web/Jobs/Job/Details?id=${jobData.JobId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ mt: 1 }}
                  >View on SurveyHub
                </Button>
              </Box>
            ))}
          </DialogContent>
        ) : (
          <DialogContent>
            <Typography variant="body1">No previous jobs found with matching UDPRN.</Typography>
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={() => setPrevJobsDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
        </Dialog>  
    
    </Box>

  );
};

export default NewLenderAudit;
